module.exports = __webpack_public_path__ + "static/img/13.7838fe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ITInfrastructure/13.png
// module id = NO2F
// module chunks = 1